import type { TOC } from '@ember/component/template-only';

export interface TuitionAssistanceCardsGenericSignature {
  Blocks: {
    body: [];
    footer: [];
    headerRight: [];
    headerTitle: [];
  };
  Element: HTMLDivElement;
}

const TuitionAssistanceCardsGeneric: TOC<TuitionAssistanceCardsGenericSignature> = <template>
  <div
    class="tio-col-flush border tio-border-subtle rounded-3xl w-full max-w-sm min-h-60 sm:min-w-96 py-6 px-4"
    ...attributes
  >
    <div class="flex">
      <div class="grow tio-text-xl-bold">{{yield to="headerTitle"}}</div>
      <div>{{yield to="headerRight"}}</div>
    </div>

    <div class="mt-2 tio-flex-between grow flex-col">
      <div class="grow">
        {{yield to="body"}}
      </div>
      <div>
        {{yield to="footer"}}
      </div>
    </div>
  </div>
</template>;

export default TuitionAssistanceCardsGeneric;
